import { AiFillTikTok } from "react-icons/ai";
import { BsTruck } from "react-icons/bs";
import { FaFacebook, FaMapPin, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
const ProblemAndDelivery = () => {
  const { theme, language } = useSettings();
  const isDark = theme === "dark";
  return (
    <div className="w-full md:col-span-2 lg:col-span-3 px-4">
      <div
        lang="bn"
        className="relative overflow-hidden rounded-lg p-[1px] bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 mb-5"
      >
        {/* Inner Card */}
        <div className="bg-white rounded-2xl px-4 md:px-6 py-4 text-center">
          {/* Title */}
          <p className={`text-sm md:text-base font-semibold ${isDark?"text-white":"text-gray-800"}`}>
            {t("problemWithOrder", language)}
          </p>

          {/* Subtitle */}
          <p className="text-xs md:text-sm text-gray-500 mt-1">
            {t("contactWithUs", language)}
          </p>

          {/* Call Button */}
          <div className="mt-2 flex justify-center">
            <a
              href="tel:01910060071"
              className="flex items-center gap-2 px-4 py-2 rounded-full 
        bg-gradient-to-r from-orange-500 to-red-500 
        text-white text-sm md:text-base font-semibold 
        shadow-md hover:shadow-lg hover:scale-[1.03] 
        transition-all duration-300"
            >
              <span className="text-base">📞</span>
              {t("phoneNumber", language)}
            </a>
          </div>
        </div>
      </div>
      <div className="mb-5 rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
        {/* Header */}
        <div className="px-4 py-3 border-b bg-gradient-to-r from-gray-100 to-gray-50">
          <p className="text-sm md:text-base font-semibold text-gray-800 ">
            🚚 {t("deliveryOptions", language)}
          </p>
        </div>

        {/* Content */}
        <div className="p-4 space-y-2 ">
          {/* Inside Dhaka */}
          <div
            className="flex items-center justify-between p-3 rounded-xl 
      bg-green-50 hover:bg-green-100 transition-all duration-300 cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-xl bg-white shadow-sm text-green-600">
                <FaMapPin size={18} />
              </div>

              <div>
                <p className="text-sm font-semibold text-gray-800">
                  {t("insideDhaka", language)}
                </p>
                <p className="text-xs text-gray-500">
                  {t("deliveryWithin24Hours", language)}
                </p>
              </div>
            </div>

            <span className="text-xs font-medium text-green-600 bg-green-100 px-2 py-1 rounded-full">
               {t("fast", language)}
            </span>
          </div>

          {/* Outside Dhaka */}
          <div
            className="flex items-center justify-between p-3 rounded-xl 
      bg-blue-50 hover:bg-blue-100 transition-all duration-300 cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-xl bg-white shadow-sm text-blue-600">
                <BsTruck size={18} />
              </div>

              <div>
                <p className="text-sm font-semibold text-gray-800">
                  {t("outsideDhaka", language)}
                </p>
                <p className="text-xs text-gray-500">
                  {t("deliveryWithin2Hours", language)}
                </p>
              </div>
            </div>

            <span className="text-xs font-medium text-blue-600 bg-blue-100 px-2 py-1 rounded-full">
               {t("standard", language)}
            </span>
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-gray-200 bg-gray-100 shadow-sm px-5 py-2 text-center">
        {/* Title */}
        <p className={`text-base md:text-lg font-semibold ${isDark?"text-white":"text-gray-800"}`}>
          {t("connectWithUs", language)}
        </p>

        <p className="text-xs text-gray-500 mt-1"> {t("followUsOnSocialMedia", language)}</p>

        {/* Icons */}
        <div className="flex justify-center mt-4 gap-3 mb-2 flex-wrap">
          {/* Facebook */}
          <a
            href="https://www.facebook.com/share/1AoiGtts1W/"
            target="_blank"
            rel="noopener noreferrer"
            className="group p-3 rounded-xl bg-blue-50 text-blue-600 
      hover:bg-blue-600 hover:text-white 
      transition-all duration-300 
      hover:scale-110 hover:shadow-lg"
          >
            <FaFacebook className="text-xl" />
          </a>

          {/* TikTok */}
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className={`group p-3 rounded-xl ${isDark?"bg-gray-700":"bg-white"} text-black 
      hover:bg-black hover:text-white 
      transition-all duration-300 
      hover:scale-110 hover:shadow-lg`}
          >
            <AiFillTikTok className="text-xl" />
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/8801910060071"
            target="_blank"
            rel="noopener noreferrer"
            className="group p-3 rounded-xl bg-green-50 text-green-600 
      hover:bg-green-600 hover:text-white 
      transition-all duration-300 
      hover:scale-110 hover:shadow-lg"
          >
            <FaWhatsapp className="text-xl" />
          </a>

          {/* YouTube */}
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="group p-3 rounded-xl bg-red-50 text-red-600 
      hover:bg-red-600 hover:text-white 
      transition-all duration-300 
      hover:scale-110 hover:shadow-lg"
          >
            <FaYoutube className="text-xl" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProblemAndDelivery;
